import {
  getPrivateSessionState,
  subscribePrivateSession,
} from "@/lib/api/private-session";

/** Keep the successful submit responsible for routing while its session read retries. */
export function waitForLoginSession(generation: number): Promise<void> {
  const pending = () => {
    const current = getPrivateSessionState();
    return current.generation === generation && current.changing;
  };
  if (!pending()) return Promise.resolve();

  return new Promise((resolve) => {
    const settled = () => {
      if (pending()) return;
      unsubscribe();
      resolve();
    };
    const unsubscribe = subscribePrivateSession(settled);
    settled();
  });
}
